'use strict';

class ChallengesEventsController {
  constructor($scope,
              $filter,
              $state,
              utils,
              config,
              ChallengesService) {

    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.timeFormatStr = $t('datetime.mdyHM12');
    $scope.challengeTypes = config.getConfigByKey('challengeTypes');
    $scope.challengeStatuses = config.getConfigByKey('challengeStatuses');
    $scope.searchVal = '';
    $scope.sortCol = 'startDateMs';
    $scope.sortBy = ['startDateMs'];
    $scope.sortReverse = true;

    $scope.firstRow = 0;
    $scope.challenges = [];
    $scope.loading = false;

    // Toggle Filter Function
    $scope.toggleFilter = function() {
      $('#filter').transition('fade down');
    };

    $scope.resetFilters = function() {
      $scope.selectedStatusId = null;
      $scope.filterChallenges();
    };

    $scope.filterChallenges = function() {
      $scope.refreshChallenges();
    };

    //save filter and init filter begin
    let filterKey = 'Filter-Challenges-' + $scope.orgInfo.id;
    $scope.cacheFilter = false;
    $scope.saveFilter = function(params) {
      if ($scope.cacheFilter) { //cache filter
        utils.setStorageItem(filterKey, params);
      } else { //remove filter
        utils.removeStorageItem(filterKey);
      }
    };

    $scope.initFilterFromCache = function() {
      let params = utils.getStorageItem(filterKey);
      if (params) {
        $scope.cacheFilter = true;
        $scope.selectedStatusId = params.selectedStatusId;
        $scope.searchVal = params.searchVal;
      }
    };
    //init filter
    $scope.initFilterFromCache();

    $scope.$watchGroup(['cacheFilter', 'selectedStatusId', 'searchVal'], function() {
      let params = {
        searchVal: $scope.searchVal,
        selectedStatusId: $scope.selectedStatusId
      };
      $scope.saveFilter(params);
    });
    //save filter and init filter end

    $scope.sortChallenges = function(event, colName) {
      $scope.sortReverse = !$scope.sortReverse;
      $scope.sortCol = colName;
      if ('type' == colName) {
        $scope.sortBy = function() {
          let type = utils.getChallengeType();
          return $t('challenges.types.' + type);
        };
      } else {
        $scope.sortBy = [colName];
      }
    };

    let getParameters = function() {
      let params = {
        'sortCollection': 'challenges',
        'sortBy': 'challengeId',
        'sortOrder': 'desc',
        'rowCount': 20,
        'firstRow': $scope.firstRow,
        'parentId': $scope.challengeId
      };
      if (angular.isDefined($scope.selectedStatusId) && $scope.selectedStatusId != '') {
        params.status = $scope.selectedStatusId;
      }
      if ($scope.searchVal && $scope.searchVal != '') {
        params.searchBy = $scope.searchVal;
      }
      return params;
    };

    $scope.editChallenge = function(c) {
      utils.setStorageItem('Selected-Challenge', c);
      let typeId = utils.getChallengeType(c);
      if (typeId == '1400') {
        $state.go('main.challenges.demand', { id: c.challengeId });
      } else if (typeId == '14001') {
        $state.go('main.challenges.weather', { id: c.challengeId });
      } else {
        console.log('Not supported challenge type');
      }
    };

    $scope.deleteChallenge = function(c) {
      return ChallengesService.deleteChallenge($scope.orgInfo.id, c.challengeId)
        .then(function(data) {
          $scope.challenges = $scope.challenges.filter(item => item.challengeId !== c.challengeId);
          return data;
        });
    };

    $scope.changeStatus = function(challenge, status) {
      return ChallengesService.updateChallengeStatus($scope.orgInfo.id, challenge.challengeId, status)
        .then(function(data) {
          challenge.status = status;
          return data;
        });
    };

    let getChallenges = function() {
      let params = getParameters();
      $scope.loading = true;
      return ChallengesService.getChallenges($scope.orgInfo.id, params);
    };

    let getChallengesCompleted = function(data) {
      $scope.loading = false;
      $scope.totalSize = data.collectionTotalSize;
      if (!data.challenges) {
        return;
      }
      data.challenges.forEach(function(c, index) {
        c.type = utils.getChallengeType(c);
        c.typeDesc = $t('challenges.types.' + c.type);
      });
      $scope.firstRow += data.challenges.length;
      let arr = $scope.challenges.concat(data.challenges);
      $scope.challenges = utils.uniqueArray(arr, 'id');
    };

    $scope.refreshChallenges = function() {
      $scope.firstRow = 0;
      $scope.totalSize = 0;
      $scope.challenges = [];
      getChallenges().then(getChallengesCompleted);
    };

    $scope.getMoreChallenges = function() {
      getChallenges().then(getChallengesCompleted);
    };

    //init , get data
    getChallenges().then(getChallengesCompleted);
  }
}

export default angular
  .module('main.challenges.events.controller', [])
  .controller('ChallengesEventsController', ChallengesEventsController)
  .name;
